/**
 * M10：列对齐的图标按钮。
 *
 * 为什么单独成文件：`BoardPage.tsx` 有两千多行，之前就地改 JSX 出过两次事故，
 * 新 UI 一律拆成小文件（见 PLAN §5.35 规矩 5）。
 *
 * 四个图标：
 *   left   —— 左对齐：三条线左端对齐，长度递减
 *   center —— 居中：三条线居中，长度递减
 *   right  —— 右对齐：三条线右端对齐，长度递减
 *   auto   —— 跟随全局：三条等长线 + 右侧一个"链"点，示意继承
 */

export type AlignKind = 'left' | 'center' | 'right' | 'auto'

interface AlignIconProps {
  kind: AlignKind
  size?: number
}

/** 每条线的 (x1, x2) —— 以 16×16 画布为准 */
const LINES: Record<"left" | "center" | "right", [number, number][]> = {
  // 三条线的**长度相同**（10 / 6 / 8），只有起点不同 —— 这样 16px 下也能一眼分辨
  left: [
    [2, 12],
    [2, 8],
    [2, 10],
  ],
  center: [
    [3, 13],
    [5, 11],
    [4, 12],
  ],
  right: [
    [4, 14],
    [8, 14],
    [6, 14],
  ],
}

export function AlignIcon({ kind, size = 16 }: AlignIconProps) {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 16 16',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round' as const,
    'aria-hidden': true,
  }

  if (kind === 'auto') {
    // 三条等长线 + 右侧"继承"点
    return (
      <svg {...common}>
        <line x1="2" y1="4" x2="11" y2="4" />
        <line x1="2" y1="8" x2="11" y2="8" />
        <line x1="2" y1="12" x2="11" y2="12" />
        <circle cx="13.5" cy="8" r="1.4" fill="currentColor" stroke="none" />
      </svg>
    )
  }

  const rows = LINES[kind]
  return (
    <svg {...common}>
      {rows.map(([x1, x2], i) => (
        <line key={i} x1={x1} y1={4 + i * 4} x2={x2} y2={4 + i * 4} />
      ))}
    </svg>
  )
}
